import React from "react";
import "./CardSubItem.scss"
import { CircularProgress } from "@material-ui/core";

export interface ItemProps {
    rightLabel?: string;
    leftLabel?: string;

}

export interface ItemState {

}

class CardSubItem extends React.Component<ItemProps, ItemState> {
    constructor(props: ItemProps) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="label">
                    <div className="left-text">
                        <p><a>{this.props.rightLabel}</a></p>
                    </div>
                    <div className="right-text">
                        <p><a>{this.props.leftLabel}</a></p></div>

            </div>
        );
    }
}

export default CardSubItem;